// ! DO NOT UPDATE THIS FILE
// ! THIS FILE IS ONLY USED AS A BACKWARDS COMPATABILITY MECHANISM
// ! IF YOU NEED TO MAKE A CHANGE, CONSIDER USING `@wrstudios/theme` INSTEAD

export const page = {
  twoColumn: 768,
  oneColumn: 576
};
